export default __webpack_public_path__ + "static/media/google-analytics-image.9e5b5255.svg";